import authAxios from "../authAxios";

export const submitLeaderApplication = (data) =>
  authAxios.post("/v1/leader-application/submit", data);

export const getLeaderApplicationStatus = (batch) =>
  authAxios.get("/v1/leader-application/status", { params: { batch } });
